import React, { useState, useEffect } from 'react'
import Loader from '../../components/Loader'

import { LOGIN_API } from "../../configs/urls";

import { postApi } from "../../services/api";
import { saveUserCredentials } from "../../services/localstorage";
import { useHistory } from "react-router-dom";
import { FaEye, FaEyeSlash } from 'react-icons/fa'

import useForm from "../../formValidator/userForm";

import "./styles.css";

import {
	Row,
	Col,
	FormGroup,
	FormFeedback,
	Input,
	Button,
} from 'reactstrap';

const Login = () => {

	const [isLoading, setIsLoading] = useState(false);
	const [canShowPassword, setCanShowPassword] = useState(false);
	const history = useHistory();

	const validate = (values) => {
		let errors = {};

		if (!values.mobile_no) {
			errors.mobile_no = "Mobile no is required.";
		}

		if (!values.password) {
			errors.password = "Password is required";
		}

		return errors;
	};


	const loginUser = () => {
		setIsLoading(true);
		postApi(LOGIN_API, params)
			.then(
				(res) => {
					saveUserCredentials(res.data, res.token);
					history.replace("/admin/dashboard");
				},
				(err) => {
					console.log(err);
				}
			)
			.finally(() => {
				setIsLoading(false);
			});
	};

	const { params, errors, handleChange, handleSubmit } = useForm(
		loginUser,
		validate
	);


	useEffect(() => {
		manageRedirection();
		return function () {
			/**
			 * Add cleanup code here
			 */
			// setIsRequestig(false);
		};
	});

	const manageRedirection = () => {
		if (localStorage.user) {
			history.replace("/admin/dashboard");
		}
	};

	return (
		<div className="login-container">
			<div className="login-logo-container">
				<img className="login-logo" src={require("assets/img/logo.png")} />
			</div>
			<form className="login-form" onSubmit={handleSubmit}>
				<Row>
					<Col className="px-1">
						<FormGroup>
							<label>User Name</label>
							<Input
								name="mobile_no"
								placeholder="Mobile no"
								type="text"
								value={params.mobile_no || ""}
								onChange={handleChange}
								invalid={errors.mobile_no && errors.mobile_no.length > 0 ? true : false}
							/>
							<FormFeedback>{errors.mobile_no}</FormFeedback>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col className="px-1">
						<FormGroup>
							<label>Password</label>
							<Input
								placeholder="password"
								id="password"
								name="password"
								type={canShowPassword ? "text" : "password"}
								value={params.password || ""}
								onChange={handleChange}
								invalid={errors.password && errors.password.length > 0 ? true : false}
							/>
							{!canShowPassword && <FaEye className="password-eye" onClick={() => setCanShowPassword(!canShowPassword)} />}
							{canShowPassword && <FaEyeSlash className="password-eye" onClick={() => setCanShowPassword(!canShowPassword)} />}
							<FormFeedback>{errors.password}</FormFeedback>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<div className="ml-auto mr-auto">
						<Button
							className="btn-round"
							color="primary"
							type="submit"
						>
							Login
						</Button>
					</div>
				</Row>
			</form>
			<Loader isLoading={isLoading} />
		</div>
	)
}

export default Login